"use client";

import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const STEPS = [
	{ index: 1, key: "processesStep1" },
	{ index: 2, key: "processesStep2" },
	{ index: 3, key: "processesStep3" },
	{ index: 4, key: "processesStep4" },
	{ index: 5, key: "processesStep5" },
	{ index: 6, key: "processesStep6" },
] as const;

export default function LowPressureCastingProcesses() {
	const t = useTranslations("new-low-pressure-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 flex flex-col items-start justify-between gap-4 sm:mb-8 sm:flex-row sm:items-center md:mb-10 lg:mb-12">
					<div>
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("processesTitle")}
						</h2>
						<p className="text-sm leading-relaxed text-black md:text-base">{t("processesDesc")}</p>
					</div>
					<Link
						href="/upload"
						className="inline-flex shrink-0 items-center justify-center rounded-lg bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] hover:text-white"
					>
						{t("processesUploadQuote")}
					</Link>
				</header>

				<div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
					{STEPS.map((step) => (
						<article
							key={step.key}
							className="bg-[#ffffff] px-6 pb-5 shadow-card transition-shadow hover:shadow-md"
						>
							<div className="mb-4 flex h-9 w-9 items-center justify-center bg-themePrimary400 text-base font-bold text-white">
								{step.index}
							</div>
							<h3 className="mb-2 text-lg font-bold text-black sm:mb-3 sm:text-xl">
								{t(`${step.key}Title`)}
							</h3>
							<p className="text-sm leading-relaxed text-black md:text-base">{t(`${step.key}Desc`)}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
